import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import theme from 'theme'

const Container = styled(Flex).attrs({
  alignItems: 'center',
})`
  color: ${theme.colors.black};
  font-weight: ${theme.fontWeights.light};
  font-size: ${theme.fontSizes[40]}px;
`

const ImageContainer = styled(Box).withConfig({
  shouldForwardProp: (prop) => ['isNewHeadshot'].indexOf(prop) === -1,
})`
  border-radius: 50px;
  width: 40px;
  height: 40px;
  overflow: hidden;
  margin: 0 15px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isNewHeadshot }) =>
    isNewHeadshot &&
    `
    img {
      width: 175% !important;
      left: -13px !important;
    }
  `}

  ${({ isNewNewHeadshot }) =>
    isNewNewHeadshot &&
    `
    img {
      left: -15px !important;
    }
  `}
`

const Name = styled.div.attrs({
  id: 'author-name',
})`
  line-height: 1;
  font-size: 14px;
`

const PostDate = styled.span`
  display: block;
  line-height: 1;
`

const Dot = styled(Box).attrs({
  mx: '2px',
})``

const newHeadshotters = {
  fostimus: { height: '100%' },
  manggit: { height: '100%' },
  newhouse: { height: '100%' },
  inshaal93: { height: '100%' },
  amyanvil: { height: '100%' },
  imsolost: { height: '100%' },
}

const newNewHeadShotters = ['amyanvil', 'imsolost']

const Author = ({ date, author: normalizedAuthor, className, showImage }) => {
  const {
    allSanityAuthorDocument: { nodes: authors },
  } = useStaticQuery(graphql`
    query MyQuery {
      allSanityAuthorDocument {
        nodes {
          _id
          person {
            firstName
            lastName
            image {
              asset {
                gatsbyImageData
                altText
              }
            }
          }
          github
        }
      }
    }
  `)

  // TODO: probably don't need to query sanity here, we can just pass down
  // the author first and last name from lib/content/index.js
  //
  // BUT: this is needed to have author content controlled by sanity, while
  // still having the chosen author determined by markdown frontmatter
  const author = authors?.find(
    (author) => author?._id === normalizedAuthor?._id
  )

  const name =
    normalizedAuthor?.name ||
    (author?.person?.firstName && author?.person?.lastName)
      ? `${author?.person?.firstName} ${author?.person?.lastName}`
      : 'Anvil Staff'
  const image = normalizedAuthor?.image || author?.person?.image
  const githubAuthor = author?.github

  const isNewHeadshot = newHeadshotters?.[githubAuthor]
  const newHeadshotStyles = newHeadshotters?.[githubAuthor] || {}
  return (
    <Container className={className}>
      {showImage && image?.asset?.gatsbyImageData && (
        <ImageContainer
          isNewHeadshot={isNewHeadshot}
          isNewNewHeadshot={newNewHeadShotters.includes(githubAuthor)}
        >
          <GatsbyImage
            style={{ ...newHeadshotStyles }}
            image={getImage(image?.asset?.gatsbyImageData)}
            alt={image?.asset?.altText || 'Author headshot'}
          />
        </ImageContainer>
      )}
      <Name>By {name}</Name>
      {date && (
        <>
          <Dot> ∙ </Dot>
          <PostDate itemProp="datePublished dateModified">
            Updated {date}
          </PostDate>
        </>
      )}
    </Container>
  )
}

Author.defaultProps = {
  showImage: true,
}

Author.propTypes = {
  date: PropTypes.string,
  author: PropTypes.string.isRequired,
  className: PropTypes.string,
  showImage: PropTypes.bool,
}

export default Author
